import { render, staticRenderFns } from "./BrokerFundDetail.vue?vue&type=template&id=28854c56&"
import script from "./BrokerFundDetail.vue?vue&type=script&lang=js&"
export * from "./BrokerFundDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrokerFundDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports